export class GetDealStatuses {
  static readonly type = '[DealStatuses] GetDealStatuses';
  constructor() {}
}